import { createContext, useState, useEffect } from "react";
import API from "../api/apiClient";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = (token, userData) => {
    localStorage.setItem("token", token);
    API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
  };

  const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("jrj_disclaimer_accepted");
  delete API.defaults.headers.common["Authorization"];
  setUser(null);
};


  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setLoading(false);
      return;
    }

    API.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    API.get("/auth/me")
      .then((res) => {
        setUser(res.data);
      })
      .catch(() => logout())
      .finally(() => setLoading(false));
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
